<template>
    <div>
        <Transition name="fade">
            <div @click="closeAction" v-if="isOpen" style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.2); z-index: 10;"></div>
        </Transition>
        <CommonPopupFrame :isShowBackground="false" :changeHeight="'auto'" :isOpen="isOpen" :closeCompleteAction="closeAction" :changeBottom="30">
            <div style="padding: 0 24px;">
                <div class="common_popup_header"></div>
                <div style="display: flex; align-items: center; gap: 5px; margin-top: 20px;">
                    <div style="font-weight: 900; font-size: 20px; line-height: 32px;">인스타그램 이벤트 참여하기</div>
                    <div @click="showInstaPopup">
                        <img style="width: 20px" :src="require('@/assets/img/guide_icon.png')" alt="">
                    </div>
                </div>
                <div style="margin-top: 20px;">
                    <div style="font-weight: 700; font-size: 12px; line-height: 24px; color: #808080;">@soccerhow_official 태그가 포함된 스토리 게시물</div>
                    <div v-if="instaImage.length === 0" @click="showInstaImage" class="image_container">
                        <div>
                            <img style="width: 24px;" :src="require('@/assets/img/img_icon_black.png')" alt="">
                        </div>
                        <div class="image_container_text">여기를 눌러 사진 선택</div>
                    </div>
                    <div v-else class="upload_image_container hide_scroll">
                        <div v-for="each, i in instaImage" :key="each.id">
                            <div v-if="each" style="position: relative; width: 112px; height: 150px; margin-right: 10px; ">
                                <img style="border-radius: 12px; object-fit: cover; width: 100%; height: 100%;" :src="each.src" alt="" />
                                <div @click="deleteInstaImage(i)" style="position: absolute; right: 6px; bottom: 6px;">
                                    <img style="width: 32px;" :src="require('@/assets/img/delete_img.png')" alt="">
                                </div>
                            </div>
                        </div>
                        <div v-if="instaImage.length < 5" @click="showInstaImage" class="upload_image_box">
                            <div>
                                <img style="width: 24px;" :src="require('@/assets/img/img_icon.png')" alt="">
                            </div>
                        </div>
                    </div>
                </div>
                <div style="margin-top: 20px;">
                    <div style="font-weight: 500; font-size: 12px; line-height: 20px;">⏳ 관리자가 직접 확인하여 처리에 하루 정도 걸릴 수 있습니다.</div>
                    <div style="font-weight: 500; font-size: 12px; line-height: 20px; margin-top: 5px;">⚠️ 무관한 사진 업로드 시 인증이 거절될 수 있습니다</div>
                </div>
                <div style="margin-top: 20px;">
                    <div @click="save" :class="{ 'active': instaImage.length > 0 }" class="common_btn">인증하기</div>
                </div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import ResponseCode  from '@/ResponseCode'
import { INSTA_POPUP_TYPE, MEMBER_INSTARGRAM_EVENT_STATE } from '@/Constants'

export default {
    name: 'ExpertFeedbackModal',
    components: { CommonPopupFrame },
    props: {
        completeAction: {
            type: Function,
            default: () => {}
        },
        writtenInfo: {
            type: Object,
            default: () => {}
        }
    },
    mounted() {
        setTimeout(() => {
            this.isOpen = true;
        }, 100)
    },
    data() {
        return {    
            MEMBER_INSTARGRAM_EVENT_STATE: MEMBER_INSTARGRAM_EVENT_STATE,
            INSTA_POPUP_TYPE: INSTA_POPUP_TYPE,
            isOpen: false,
            instaImage: [],
            instaImageNextId: 0,
            instaImageInputs: {},
        }
    },
    methods: {
        async save() {
            if (this.writtenInfo && this.writtenInfo.state == MEMBER_INSTARGRAM_EVENT_STATE.WAITING) {
                this.$GlobalStore.addModal('MemberPopupList', {
                    transitionName: '',
                    isModalBackTransparent: true,
                    type: INSTA_POPUP_TYPE.CONFIRM,
                })
                return
            }
            if (this.instaImage.length === 0) {
                this.$GlobalStore.showAlert('사진을 업로드해주세요.')
                return
            }
            this.$GlobalStore.addModal('Loading', {
                transitionName: '',
                isModalBackTransparent: true,
            })
            const formData = new FormData()
            for (let i = 0; i < this.instaImage.length; i++) {
                    const fileData = this.instaImage[i];
                if (fileData?.isFileTag && this.instaImageInputs?.[fileData.id]) {
                    const input = this.instaImageInputs[fileData.id];
                    if (input.files?.[0]) {
                        formData.append('file' + i, input.files[0]);
                    }
                }
            }
            const res = await this.$Axios.post('/api/soccerhow/request/instargram_event/save', formData, { headers: { 'Content-Type': 'multipart/form-data' } })
            if (res.data.code == ResponseCode.SUCCESS) {
                this.$GlobalStore.closeLastModal()
                this.completeAction()
                this.closeAction()
            }
        },
        closeAction() {
            this.isOpen = false;
            setTimeout(() => {
                this.$GlobalStore.closeLastModal();
            }, 300)
        },
        showInstaImage() {
            if (this.instaImage.length >= 5) return
            const newId = this.instaImageNextId++
            const fileId = 'insta_file' + newId
            this.makeInstaImageInput(fileId)
            const input = this.instaImageInputs[fileId]
            if (input) input.click()
        },
        makeInstaImageInput(fileId) {
            if (this.instaImageInputs[fileId]) return
            const input = document.createElement('input')
            input.type = 'file'
            input.style.display = 'none'
            input.dataset.id = fileId
            input.addEventListener('change', (e) => this.readInstaImageURL(e))
            document.body.appendChild(input)
            this.instaImageInputs[fileId] = input
        },
        readInstaImageURL(e) {
            const input = e.currentTarget;

            if (input.files && input.files[0]) {
                var extension = input.files[0].name.split('.').pop().toLowerCase();

                if (extension === 'png' || extension === 'jpg' || extension === 'jpeg' || extension === 'bmp' || extension === 'gif' || extension === 'webp' || extension === 'mp4' || extension === 'mov' || extension === 'qt') {

                    var reader = new FileReader();
                    reader.onload = (e) => {
                        if (input.files[0].size > 1024 * 1024 * 1024) {
                            input.files[0].value = '';
                            this.$GlobalStore.showAlert('업로드 가능한 용량은 최대 1GB 입니다.');
                            return;
                        }

                        const data = { src: e.target.result, isVideo: false, id: input.getAttribute('data-id'), isFileTag: true, isEnlarge: false, large_width: 0, large_height: 0, default_width: 0, default_height: 0 };
                        if (extension === 'mp4' || extension === 'mov' || extension === 'qt') data.isVideo = true
                        this.instaImage.push(data)
                    }
                    reader.readAsDataURL(input.files[0]);
                } else {
                    this.$GlobalStore.showAlert('확장자 png, jpg, bmp, gif, webp, mp4, mov, qt만 업로드 가능합니다.');
                }
            }
        },
        deleteInstaImage(i) {
            const file = this.instaImage[i]
            const fileId = file?.id
            this.instaImage.splice(i, 1)
            if (fileId && this.instaImageInputs[fileId]) {
                const input = this.instaImageInputs[fileId]
                input.value = ''
                input.removeEventListener('change', this.readInstaImageURL)
                if (input.parentNode) input.parentNode.removeChild(input)
                delete this.instaImageInputs[fileId]
            }
        },
        showInstaPopup() {
            this.$GlobalStore.addModal('MemberPopupList', {
                transitionName: '',
                isModalBackTransparent: true,
                type: INSTA_POPUP_TYPE.METHOD,
            })
        },
    }
}
</script>

<style scoped>
.upload_image_box {
    position: relative;
    border-radius: 12px;
    border: 2px dashed #d9d9d9;
    height: 150px;
    width: 219px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
}

.upload_image_container {
    display: flex;
    overflow-x: scroll;
    margin: 0 -20px;
    padding: 0 20px;
}

.common_popup_header {
    width: 36px;
    height: 5px;
    background-color: #d9d9d9;
    margin: 0 auto;
    border-radius: 5px;
    margin-top: 5px;
}

.common_btn {
    padding: 16px 0;
    color: #797979;
    font-size: 14px;
    font-weight: 700;
    border-radius: 12px;
    background-color: #d9d9d9;
    text-align: center;
}

.common_btn.active {
    background-color: var(--color-main);
    color: #fff;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.image_container {
    border-radius: 12px;
    border: 2px dashed #210F034D;
    background-color: #210F031A;
    height: 150px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.image_container_text {
    font-weight: 700;
    font-size: 12px;
    line-height: 24px;
    margin-top: 8px;
}
</style>